// Safely parses and returns the product JSON from the page's global variables.
function getProductJson() {
  if (typeof gsf_conversion_data !== 'undefined' && gsf_conversion_data.data && gsf_conversion_data.data.product_data) {
    // The theme uses a global gsf_conversion_data variable.
    // We need to remap its structure to match what the rest of the script expects.
    return {
      variants: gsf_conversion_data.data.product_data.map(function(variant) {
        return {
          id: variant.variant_id,
          // Add other variant properties here if needed in the future
        };
      })
    };
  } else {
    // Fallback for the old method, just in case.
    var scriptTag = document.querySelector('[data-product-json]');
    if (scriptTag && scriptTag.innerHTML) {
      try {
        return JSON.parse(scriptTag.innerHTML);
      } catch (e) {
        console.error('Error parsing product JSON:', e);
        return null;
      }
    }
  }
  return null;
}

// Returns the user's current local time.
function getUserLocalTime() {
    var now = new Date();
    var formatter = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    var parts = formatter.formatToParts(now);
    var year = parts.find(p => p.type === "year").value;
    var month = parts.find(p => p.type === "month").value;
    var day = parts.find(p => p.type === "day").value;
    var hour = parts.find(p => p.type === "hour").value;
    var minute = parts.find(p => p.type === "minute").value;
    var second = parts.find(p => p.type === "second").value;
    var userTime = new Date(year, month - 1, day, hour, minute, second);
    console.log("User's local time computed:", userTime, "getDay:", userTime.getDay());
    return userTime;
  }
  
  // Returns the cutoff time for a given date.
  // The cutoff time is 3pm.
  function getCutoffTime(date) {
    var cutoff = new Date(date);
    cutoff.setHours(15, 0, 0, 0); // 3pm
    return cutoff;
  }
  
  // Computes the delivery day based on the current time (now).
  // Shipping occurs on Saturdays; Sunday is not a shipping day.
  function getDeliveryDay(now) {
    console.log("getDeliveryDay: now =", now, "day =", now.getDay());
    var cutoff = getCutoffTime(now);
    var deliveryDay = new Date(now);

    const isShippingDay = (d) => d.getDay() !== 0; // Not Sunday

    // If it's after cutoff on a shipping day, start counting from the next day.
    if (now >= cutoff && isShippingDay(now)) {
        deliveryDay.setDate(deliveryDay.getDate() + 1);
    }

    // Ensure the starting day is a shipping day.
    while (!isShippingDay(deliveryDay)) {
        deliveryDay.setDate(deliveryDay.getDate() + 1);
    }

    // Add 2 shipping days for delivery.
    var daysToAdd = 2;
    while (daysToAdd > 0) {
        deliveryDay.setDate(deliveryDay.getDate() + 1);
        // Decrement if the new day is a shipping day.
        if (isShippingDay(deliveryDay)) {
            daysToAdd--;
        }
    }

    console.log("Delivery day computed as:", deliveryDay);
    return deliveryDay;
  }
  
  // Determines the next order cutoff time.
  // Special rule: If today is Sunday, use Monday's cutoff (4pm).
  function getNextOrderCutoff(now) {
    if (now.getDay() === 0) {
      var monday = new Date(now);
      monday.setDate(now.getDate() + 1);
      return getCutoffTime(monday);
    }
    var cutoff = getCutoffTime(now);
    if (now < cutoff) {
      return cutoff;
    } else {
      var delivery = getDeliveryDay(now);
      var nextOrder = new Date(delivery);
      nextOrder.setDate(delivery.getDate() - 1);
      return getCutoffTime(nextOrder);
    }
  }
  
  // Updates the delivery message based on the selected variant's metafield value.
  function updateDeliveryMessage(variantId) {
    if (window.location.hostname !== 'www.shopsta.com') {
      var deliveryMessage = document.getElementById("delivery-message");
      if (deliveryMessage) {
        deliveryMessage.innerHTML = "";
      }
      toggleFasterDeliveryBlock();
      return;
    }

    console.log("updateDeliveryMessage called with variantId:", variantId);
    var messageHTML = "";
    
    if (variantInventory[variantId] && variantInventory[variantId] > 0) {
      var now = getUserLocalTime();
      var deliveryDay = getDeliveryDay(now);
      var cutoff = getNextOrderCutoff(now);
      
      // Calculate the time remaining until cutoff.
      var diffMs = cutoff - now;
      var totalMins = Math.floor(diffMs / 60000);
      var days = Math.floor(totalMins / 1440);
      var remainder = totalMins % 1440;
      var hours = Math.floor(remainder / 60);
      var minutes = remainder % 60;
      
      // Build countdownText while removing the comma after "hrs".
      var countdownText = "";
      if (days > 0) {
        countdownText += days + " day" + (days > 1 ? "s" : "");
      }
      if (hours > 0) {
        if (countdownText !== "") {
          countdownText += ", ";
        }
        countdownText += hours + " hrs";
        countdownText += " " + minutes + " mins";
      } else {
        if (countdownText !== "") {
          countdownText += ", ";
        }
        countdownText += minutes + " mins";
      }
      
      var tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      // Entire sentence is bolded.
      messageHTML = "<br><strong>";
      var weekday = deliveryDay.toLocaleDateString('en-US', { weekday: 'long' });
      var day = deliveryDay.getDate();
      var month = deliveryDay.toLocaleDateString('en-US', { month: 'long' });
      var displayDate = weekday + ", " + month + " " + day;

      messageHTML += "Get it by <span style='color:black;'>" + displayDate + "</span>. Order within " + countdownText + ".";
      messageHTML += "</strong>";
    }
    document.getElementById("delivery-message").innerHTML = messageHTML;
    toggleFasterDeliveryBlock();
  }
  
  // Toggles the faster delivery block based on whether the delivery message is visible.
  function toggleFasterDeliveryBlock() {
    var deliveryMessage = document.getElementById("delivery-message");
    var fasterBlock = document.getElementById("faster-delivery");
    if (deliveryMessage && fasterBlock) {
      if (deliveryMessage.innerText.trim().length > 0) {
        fasterBlock.style.display = "none";
      } else {
        fasterBlock.style.display = "block";
      }
    }
  }
  
  // Attach event listeners.
  document.addEventListener("DOMContentLoaded", function() {
    console.log("DOMContentLoaded event fired.");
    
    var variantSelect = document.getElementById("ProductSelect-product-template") || document.querySelector('select[name="id"]');
    if (variantSelect) {
      console.log("Variant select element found:", variantSelect);
      updateDeliveryMessage(variantSelect.value);
      variantSelect.addEventListener("change", function() {
        console.log("Select change event fired. New value:", this.value);
        updateDeliveryMessage(this.value);
      });
    } else {
      console.log("Variant select element not found. Checking for single variant product data.");
      var productData = getProductJson();
      if (productData && productData.variants && productData.variants.length > 0) {
        var singleVariantId = productData.variants[0].id;
        console.log("Single variant product found. Using variant ID:", singleVariantId);
        updateDeliveryMessage(singleVariantId);
      } else {
        console.log("Could not find single variant data either. Delivery message not shown.");
      }
    }
    
    var variantSelectionEl = document.querySelector('variant-selection');
    if (variantSelectionEl) {
      console.log("Custom variant-selection element found:", variantSelectionEl);
      var observer = new MutationObserver(function(mutationsList, observer) {
        mutationsList.forEach(function(mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "variant") {
            var newVariant = variantSelectionEl.getAttribute("variant");
            console.log("MutationObserver: variant attribute changed to:", newVariant);
            updateDeliveryMessage(newVariant);
          }
        });
      });
      observer.observe(variantSelectionEl, { attributes: true });
    } else {
      console.log("No custom <variant-selection> element found.");
    }
    
    document.addEventListener('variant:changed', function(e) {
      console.log("Custom event 'variant:changed' fired:", e.detail);
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        updateDeliveryMessage(e.detail.variant.id);
      }
    });
  });

    document.addEventListener('change', function (e) {
  if (e.target && e.target.matches('.options-selection__option-value-input')) {
    // let selection apply, then drop focus so no ring remains
    setTimeout(function(){ e.target.blur(); }, 0);
  }
});
// Extra safety for iOS tap behavior
document.addEventListener('touchend', function (e) {
  const el = e.target.closest('.options-selection__option-value-input');
  if (el) setTimeout(function(){ el.blur(); }, 0);
}, { passive: true });